/**
 * Create / Update interview mutations.
 * POST /api_ats/v1/ats_interviews
 * PUT  /api_ats/v1/ats_interviews/:id
 *
 * Payload shape will be finalised — keep loose typing for now.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';
import { asAtsClientBody, unwrapAtsEnvelope } from '@/api/ats/atsEnvelope';

export interface CreateInterviewVariables {
  payload: FormData | Record<string, unknown>;
}

export interface UpdateInterviewVariables {
  interviewId: number;
  payload: FormData | Record<string, unknown>;
}

export function useCreateInterview() {
  const queryClient = useQueryClient();

  return useMutation<Record<string, unknown>, Error, CreateInterviewVariables>({
    mutationFn: async ({ payload }) => {
      const raw = asAtsClientBody<unknown>(
        await http.post('/ats_interviews', payload)
      );
      return unwrapAtsEnvelope<Record<string, unknown>>(raw);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schedule-interview'] });
    },
  });
}

export function useUpdateInterview() {
  const queryClient = useQueryClient();

  return useMutation<Record<string, unknown>, Error, UpdateInterviewVariables>({
    mutationFn: async ({ interviewId, payload }) => {
      const raw = asAtsClientBody<unknown>(
        await http.put(`/ats_interviews/${interviewId}`, payload)
      );
      return unwrapAtsEnvelope<Record<string, unknown>>(raw);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schedule-interview'] });
    },
  });
}
